import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) { }
  private apiUrl = '';


  getDashboardData() {
    return this.http.get(`${this.apiUrl}/analytics/customer/dashboard`)
  }
  getStampDashboardData() {
    return this.http.get(`${this.apiUrl}/bulk-estamp/client/dashboard`)
  }

  getMonthlyDocStatus(date:any) {
    return this.http.get(`${this.apiUrl}/analytics/customer/documents/${date}`)
  }
}
